import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ModuleState {
  page: number;
  pageSize: number;
  totalElements: number;
  checked: any[];
}

const initialState: ModuleState = {
  page: 0,
  pageSize: 15,
  totalElements: 0,
  checked: [],
};

const tableSlice = createSlice({
  name: "module",
  initialState,
  reducers: {
    setPage: (state, action: PayloadAction<number | null>) => {
      state.page = action.payload;
    },
    setPageSize: (state, action: PayloadAction<number | null>) => {
      state.pageSize = action.payload;
      state.page = 0;
    },
    setTotalElements: (state, action: PayloadAction<number | null>) => {
      state.totalElements = action.payload;
    },
    resetTablePagination: (state) => {
      state.page = 0;
      state.pageSize = 15;
      state.totalElements = 0;
      state.checked = [];
    },
    setCheckedRows: (state, action: PayloadAction<any[]>) => {
      state.checked = action.payload;
    },
    clearChecked: (state) => {
      state.checked = [];
    },
  },
});

export const {
  setPage,
  setTotalElements,
  setPageSize,
  resetTablePagination,
  clearChecked,
  setCheckedRows,
} = tableSlice.actions;

export default tableSlice.reducer;
